import { FC } from 'react';
import GLIcon from 'src/components/GrowthLevelIndicator/icon';
import { SvgHelperWrapper } from 'src/components/Icon/iconHelper';
import flower0 from './flowers/flower-0.svg';
import flower1 from './flowers/flower-1.svg';
import flower2 from './flowers/flower-2.svg';
import flower3 from './flowers/flower-3.svg';
import flower4 from './flowers/flower-4.svg';
import flower5 from './flowers/flower-5.svg';
import { FULLY_GROWN_LEVEL } from './groupSummaryItems';

export type WordStatus = 'stillLearning' | 'markedAsKnown' | 'justLearned' | 'reviewed';

const GROWTH_FLOWERS = [flower0, flower1, flower2, flower3, flower4, flower5] as const;

export const GrowthFlower: FC<{ status: WordStatus; growthLevel: number }> = ({
  status,
  growthLevel,
}) => {
  if (status === 'reviewed') return <GLIcon name="glreview" />;
  if (status === 'justLearned') return <GLIcon name="gl6" />;
  if (status === 'markedAsKnown') return <GLIcon name="alreadyKnown" />;

  const level = Math.min(Math.max(growthLevel, 0), FULLY_GROWN_LEVEL - 1);
  const Flower = GROWTH_FLOWERS[level];

  return (
    <div data-testid={`gl${level}`}>
      <SvgHelperWrapper Svg={Flower} />
    </div>
  );
};
